import React from "react";
import close from "../../assets/close.svg"

import Accordion from "../../components/Accordion/Accordion";
const FiltersComponent = ({ isWeb, isOpen, toggleDrawer, filters }) => {



    return (
        isWeb ? <div className="EcommerceProduct-left ">
            <div className="EcommerceProduct-left-header">FILTERS</div>
            <Accordion items={filters} isSmall layout={"layout1"} />
        </div> : <div className={`EcommerceFilter-drawer ${isOpen ? 'open' : ''}`}>
            <div className="filter-drawer-header"><div className="header">FILTERS
            </div>
                <div className="close-container" onClick={toggleDrawer}><img alt="" src={close} /></div></div>
            <Accordion items={filters} isSmall layout={"layout1"} />

        </div>
    )
}
export default FiltersComponent